import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { PwaUpdateService } from './core/services/pwa-update.service';
import { ThemeService } from './core/services/theme.service';
import { ToastComponent } from './shared/components/toast/toast.component';
import { ConfigClientService } from './core/services';
import { NotConfigPage } from './shared/pages/not-config.page';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent, NotConfigPage],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly pwaUpdate = inject(PwaUpdateService);
  protected readonly hasUpdate = this.pwaUpdate.isUpdateAvailable;
  private readonly _theme = inject(ThemeService);
  private readonly _configClient = inject(ConfigClientService);

  readonly clientInitStatus = this._configClient.initStatus;
  readonly clientInitCodeStatus = this._configClient.statusCode;

  getMessage(statusCode: number | null): string {
    switch (statusCode) {
      case 404:
        return 'No se encontró la configuración del cliente. Verificá tu conexión a internet o contactá al soporte.';
      case 500:
        return 'Ocurrió un error al cargar la configuración del cliente. Verificá tu conexión a internet o contactá al equipo de soporte.';
      case 401:
      case 403:
        return 'No tienes permisos para acceder a la configuración del cliente. Contactá al soporte para resolver este problema.';
      default:
        return 'La configuración del cliente no se pudo cargar. Por favor, verifica que estás accediendo al subdominio correcto o contacta al soporte.';
    }
  }

  protected dismissUpdate(): void {
    this.pwaUpdate.dismissUpdate();
  }

  protected reloadForUpdate(): void {
    void this.pwaUpdate.activateUpdate();
  }
}
